import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, UnsubscribeRequest, UnsubscribeResponse } from '@ld.consumer-portal/models';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UnsubscribeService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  async validateEmail(email: string): Promise<UnsubscribeResponse> {
    const url = `${this.env.appSettings.ServicingLINCPortalBorrowers}/${this.env.appSettings.apiNamespace}/ServicingLINCPortal/Unsubscribe/ValidateEmail`;

    const body: UnsubscribeRequest = { email };

    return firstValueFrom(this.http.post<UnsubscribeResponse>(url, body));
  }

  async unsubscribe(email: string): Promise<UnsubscribeResponse> {
    const url = `${this.env.appSettings.ServicingLINCPortalBorrowers}/${this.env.appSettings.apiNamespace}/ServicingLINCPortal/Unsubscribe`;

    const body: UnsubscribeRequest = { email };

    return firstValueFrom(this.http.post<UnsubscribeResponse>(url, body));
  }
}
